export const getOrderTypeTabId = orderType =>
  `OrderTypeSelector-T-${orderType}`;

export const getOrderTypePanelId = orderType =>
  `OrderTypeSelector-P-${orderType}`;
